import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";

interface FormFields {
  code: string;
}

export const apiSignIn = async (values: {
  password: string;
  email: string;
  otp: string;
}) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });

  try {
    const uri = `/auth/login/admin`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    // Send the POST request to log in
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response if the login fails
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiVerifyAccount = async (formFields: FormFields) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/auth/verify-account/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return await Axios.patch(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      status: "error",
      msg: e?.response?.data?.message || e?.message || "An error occured",
    };
  }
};

export const apiVerifyEmail = async (value: { email: string }) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/auth/verify-account/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    formData.append("email", value?.email);
    return await Axios.post(uri, formData.toString(), cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};

export const apiForgotPasswordEmail = async (value: { email: string }) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/auth/forgot-password/admin`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    formData.append("email", value?.email);
    return await Axios.post(uri, formData.toString(), cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};

interface ApiResetPasswordPropsTypes {
  email: string;
  otp: string;
  password: string;
  token: string;
}

export const apiResetPassword = async (
  formFields: ApiResetPasswordPropsTypes
) => {
  const formData = new URLSearchParams();

  // Append all form fields to FormData
  Object.entries(formFields).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/auth/reset-password/admin`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return { status: "error", msg: e?.response?.data?.message || e?.message };
  }
};
